import { render } from "./PointExchangePage.vue?vue&type=template&id=e44d2600&scoped=true"
import script from "./PointExchangePage.vue?vue&type=script&lang=js"
export * from "./PointExchangePage.vue?vue&type=script&lang=js"

import "./PointExchangePage.vue?vue&type=style&index=0&id=e44d2600&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e44d2600"]])

export default __exports__